import { render, staticRenderFns } from "./PwaIosAddToHomescreenBanner.vue?vue&type=template&id=02467854&scoped=true"
import script from "./PwaIosAddToHomescreenBanner.vue?vue&type=script&lang=js"
export * from "./PwaIosAddToHomescreenBanner.vue?vue&type=script&lang=js"
import style0 from "./PwaIosAddToHomescreenBanner.vue?vue&type=style&index=0&id=02467854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02467854",
  null
  
)

export default component.exports